import { Tag } from '@carbon/react';
import { parseLocalDateTime } from 'utils/dates';
import type { ActivityFeedItem } from './types';
import style from './activity-item.module.scss';

interface SummaryActivityProps {
  item: ActivityFeedItem & { summary: string };
}

/**
 * Card layout for feed rows the server decorated with a `summary` sentence
 * (interest certification): action-tag chip + timestamp header, the sentence,
 * and an actor / slot-context footer. Rows without a summary keep the raw
 * VersionActivity / EventActivity rendering.
 * @param {SummaryActivityProps} props - Component props.
 * @return {JSX.Element} The rendered card.
 */
export const SummaryActivity = ({ item }: SummaryActivityProps) => {
  const { actionTag, createdAt, summary, actor, slotName } = item;

  return (
    <li className={style.summaryCard}>
      <div className={style.summaryHeader}>
        {actionTag ? (
          <Tag type={actionTag.color} size="sm" className={style.summaryTag}>
            {actionTag.label}
          </Tag>
        ) : (
          <span />
        )}
        <span className={style.summaryTimestamp}>
          {parseLocalDateTime(createdAt, true)}
        </span>
      </div>
      <p className={style.summaryText}>{summary}</p>
      <div className={style.summaryFooter}>
        <span className={style.summaryActor}>{actor}</span>
        {slotName && <span className={style.summaryContext}>{slotName}</span>}
      </div>
    </li>
  );
};
